import { createContext, useContext, useEffect, useState } from "react";
import { authLogin, authRegister, authMe, setAuthToken, getToken } from "@/lib/apiClient";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (getToken()) {
      authMe().then(setUser).catch(() => setAuthToken(null)).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const data = await authLogin({ email, password });
    setAuthToken(data.access_token);
    setUser(data.user);
  };

  const register = async (name, email, password, invite_code) => {
    const data = await authRegister({ name, email, password, invite_code });
    setAuthToken(data.access_token);
    setUser(data.user);
  };

  const logout = () => {
    setAuthToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
